import {
  CreateVenderProductOrderInput,
  VenderProductOrderStatus,
} from '@mommy/models/vender-product.model';

/** 載入團隊商品列表（team_id 由後端解析對應商家；keyword 走 API 模糊搜尋） */
export class LoadVenderProductList {
  static readonly type = '[VenderProduct] LoadVenderProductList';
  constructor(public team_id: number, public keyword?: string) {}
}

/** 載入商品詳情（含 can_order） */
export class LoadVenderProductDetail {
  static readonly type = '[VenderProduct] LoadVenderProductDetail';
  constructor(public team_id: number, public product_id: number) {}
}

/** 個案登記訂單（失敗會 rethrow，頁面據此決定是否導頁） */
export class CreateVenderProductOrder {
  static readonly type = '[VenderProduct] CreateVenderProductOrder';
  constructor(public input: CreateVenderProductOrderInput) {}
}

/** 載入我的訂單列表（不帶 team_id 即跨商家全列） */
export class LoadVenderProductOrderList {
  static readonly type = '[VenderProduct] LoadVenderProductOrderList';
  constructor(
    public team_id?: number,
    public order_status?: VenderProductOrderStatus
  ) {}
}

/** 載入訂單詳情（含價格快照明細與通知記錄） */
export class LoadVenderProductOrderDetail {
  static readonly type = '[VenderProduct] LoadVenderProductOrderDetail';
  constructor(public order_id: number) {}
}

/** 個案取消訂單（cancel_remark 必填；成功後重抓列表/詳情，失敗會 rethrow） */
export class CancelVenderProductOrder {
  static readonly type = '[VenderProduct] CancelVenderProductOrder';
  constructor(public order_id: number, public cancel_remark: string) {}
}
